import axios from "@/api/axiosInstance";
import { FetchRegistrationsReportParams } from "./types";

export const fetchRegistrationsReportCsv = async (
  params: Omit<FetchRegistrationsReportParams, "page" | "pageSize"> = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/reports/registrations/export",
    { responseType: "blob", params },
  );
  return response.data;
};
